import React from "react";

const Balouchistan = () => {
  return (
    <>
      <h1>Work in Progress</h1>
    </>
  );
};

export default Balouchistan;
